import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../../constants';
import Style from '../Style';

class Toggle extends React.PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
    onToggle: PropTypes.func,
    name: PropTypes.string,
    style: PropTypes.object,
  };
  static defaultProps = {
    checked: false,
    onToggle: (checked, name) => {},
    style: EMPTY_OBJECT,
  };

  handleClick = e => {
    e.preventDefault();
    this.props.onToggle(!this.props.checked, this.props.name);
  };

  render() {
    const { checked, onToggle, name, style, ...otherProps } = this.props;

    const colors = Style.Colors;

    const composedStyle = {
      backgroundColor: checked ? colors.white : colors.shadow5,
      borderRadius: '999999px',
      border: `0.1em solid ${checked ? colors.black : colors.shadow3}`,
      height: '1.8em',
      width: '3.2em',
      padding: '0.2em',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: checked ? 'flex-end' : 'flex-start',
    };

    const composedInnerStyle = {
      backgroundColor: checked ? colors.black : colors.shadow1,
      borderRadius: '999999px',
      height: '1.2em',
      width: '1.2em',
    };

    return (
      <div style={{ fontSize: '10px', ...style, boxSizing: 'border-box' }}>
        <div style={composedStyle} onClick={this.handleClick}>
          <div style={composedInnerStyle} />
        </div>
      </div>
    );
  }
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/Toggle/Toggle.js